module.exports = __webpack_public_path__ + "img/gift@2x-100.4f1d088a.jpg";